<div class="grid-container margin-top">
    <div class="grid-x">
        <div class="cell large-12 medium-12 small-12">
            <ag-grid-angular class="data-grid  full-page" [gridOptions]="gridOptions" [rowData]="data | async" [excelStyles]="excelStyles" aria-label="Insurance Full Data List"></ag-grid-angular>
        </div>
    </div>
</div>